import React from "react";
import { Table, TableHead, TableRow, TableCell, TableBody, Paper, TableContainer, IconButton } from "@mui/material";
import HistoryIcon from "@mui/icons-material/History";
import { StudentLogItem } from "./studentLogApi";

interface Props {
  rows: StudentLogItem[];
  onViewHistory: (studentId: string) => void;
}

const StudentLogTable: React.FC<Props> = ({ rows, onViewHistory }) => {
  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell>Student Name</TableCell>
            <TableCell>Admission No</TableCell>
            <TableCell>Scholar No</TableCell>
            <TableCell>Module</TableCell>
            <TableCell>Action</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>Performed By</TableCell>
            <TableCell>IP Address</TableCell>
            <TableCell align="right">History</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((r) => (
            <TableRow key={r.id}>
              <TableCell>{new Date(r.createdAt).toLocaleString()}</TableCell>
              <TableCell>{r.student ? `${r.student.firstName} ${r.student.lastName}` : "-"}</TableCell>
              <TableCell>{r.student?.admissionNumber || "-"}</TableCell>
              <TableCell>{r.student?.scholarNumber || "-"}</TableCell>
              <TableCell>{r.module}</TableCell>
              <TableCell>{r.action}</TableCell>
              <TableCell>{r.description}</TableCell>
              <TableCell>{r.performedBy || "-"}</TableCell>
              <TableCell>{r.ipAddress || "-"}</TableCell>
              <TableCell align="right">
                <IconButton size="small" onClick={() => onViewHistory(r.studentId)} title="View History">
                  <HistoryIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
          {rows.length === 0 && (
            <TableRow>
              <TableCell colSpan={10} align="center">
                No logs found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default StudentLogTable;
